import { css, CSSProp } from "styled-components";

const size = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1600px",
};

export const sm = (inner: CSSProp) => css`
  @media (max-width: ${size.sm}) {
    ${inner};
  }
`;
export const md = (inner: CSSProp) => css`
  @media (max-width: ${size.md}) {
    ${inner};
  }
`;
export const lg = (inner: CSSProp) => css`
  @media (max-width: ${size.lg}) {
    ${inner};
  }
`;
export const xl = (inner: CSSProp) => css`
  @media (max-width: ${size.xl}) {
    ${inner};
  }
`;
export const xxl = (inner: CSSProp) => css`
  @media (max-width: ${size.xxl}) {
    ${inner};
  }
`;
